<template>
  <div class="container mx-auto px-4 py-8">
    <h1 class="text-3xl font-bold mb-8">Data Browse</h1>
    
    <div class="flex gap-8">
      <!-- Left Navigation -->
      <div class="w-64 flex-shrink-0">
        <div class="bg-white rounded-lg shadow-lg p-4">
          <el-menu
            class="el-menu-vertical"
            :default-active="activeIndex"
            @select="handleSelect"
          >
            <el-sub-menu index="1">
              <template #title>
                <span style="font-weight: bold;">Disease</span>
              </template>
              <el-menu-item index="1-1">Tumor</el-menu-item>
              <el-menu-item index="1-2">Autoimmune disease</el-menu-item>
              <el-menu-item index="1-3">Infectious disease</el-menu-item>
            </el-sub-menu>
            <!-- <el-sub-menu index="2">
              <template #title>
                <span style="font-weight: bold;">Co-receptor</span>
              </template>
              <el-menu-item index="2-1">CD8</el-menu-item>
              <el-menu-item index="2-2">CD4</el-menu-item>
            </el-sub-menu>
            <el-sub-menu index="3">
              <template #title>
                <span style="font-weight: bold;">Cell source</span>
              </template>
              <el-menu-item index="3-1">PBMC</el-menu-item>
              <el-menu-item index="3-2">TIL</el-menu-item>
            </el-sub-menu> -->
          </el-menu>
        </div>
      </div>

      <!-- Main Content -->
      <div class="flex-1">
        <div class="bg-white rounded-lg shadow-lg p-6">
          <div class="el-row" style="min-height: 600px;">
            <div id="maodian"></div>
            <div v-for="(disease, index) in diseases" :key="index" class="disUnit el-col el-col-6" style="padding: 10px; height: 190px; word-break: normal; width: 135px;">
              <div 
                style="text-align: center; height: 190px; cursor: pointer;" 
                @click="navigateToDisease(disease.name)"
                class="disease-card"
              >
                <div class="el-image" style="height: 100px;">
                  <img :src="encodeURI(disease.image)" class="el-image__inner" style="max-width: 100%; max-height: 100%; object-fit: contain;">
                </div>
                <div class="desText" :style="{ color: disease.color, fontSize: '16px', borderBottom: disease.color === 'rgb(230, 162, 61)' ? '2px solid rgb(226, 188, 95)' : 'none' }">
                  {{ disease.name }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { ArrowDown } from '@element-plus/icons-vue'

interface Disease {
  name: string
  image: string
  color: string
}

type DiseaseData = {
  [key: string]: Disease[]
}

const activeIndex = ref('1-1')

const diseaseData: DiseaseData = {
  '1-1': [ // Tumor
    {
      name: 'Pan tumor',
      image: '/reactcr/static/images/Pan tumor.svg',
      color: '#303133'
    },
    {
      name: 'Acute myeloid leukemia',
      image: '/reactcr/static/images/Acute myeloid leukemia.svg',
      color: '#303133'
    },
    {
      name: 'Bile duct cancer',
      image: '/reactcr/static/images/Bile duct cancer.svg',
      color: '#303133'
    },
    {
      name: 'Breast cancer',
      image: '/reactcr/static/images/Breast cancer.svg',
      color: '#303133'
    },
    {
      name: 'Cancer-testis antigens',
      image: '/reactcr/static/images/Cancer-testis antigens.svg',
      color: '#303133'
    },
    {
      name: 'Chronic lymphocytic leukemia',
      image: '/reactcr/static/images/Chronic lymphocytic leukemia.svg',
      color: '#303133'
    },
    {
      name: 'Colorectal adenocarcinoma',
      image: '/reactcr/static/images/Colorectal adenocarcinoma.svg',
      color: '#303133'
    },
    {
      name: 'Colorectal cancer',
      image: '/reactcr/static/images/Colorectal cancer.svg',
      color: '#303133'
    },
    {
      name: 'Endometrial cancer',
      image: '/reactcr/static/images/Endometrial cancer.svg',
      color: '#303133'
    },
    {
      name: 'Epithelial ovarian cancer',
      image: '/reactcr/static/images/Epithelial ovarian cancer.svg',
      color: '#303133'
    },
    {
      name: 'Gastroesophageal cancer',
      image: '/reactcr/static/images/Gastroesophageal cancer.svg',
      color: '#303133'
    },
    {
      name: 'Head and neck squamous cell carcinoma',
      image: '/reactcr/static/images/Head and neck squamous cell carcinoma.svg',
      color: '#303133'
    },
    {
      name: 'Hepatocellular carcinoma',
      image: '/reactcr/static/images/Hepatocellular carcinoma.svg',
      color: '#303133'
    },
    {
      name: 'Lung cancer',
      image: '/reactcr/static/images/Lung cancer.svg',
      color: '#303133'
    },
    {
      name: 'Lymphoma',
      image: '/reactcr/static/images/Lymphoma.svg',
      color: '#303133'
    },
    {
      name: 'Melanoma',
      image: '/reactcr/static/images/Melanoma.svg',
      color: '#303133'
    },
    {
      name: 'Merkel cell carcinoma',
      image: '/reactcr/static/images/Merkel cell carcinoma.svg',
      color: '#303133'
    },
    {
      name: 'Metastatic colorectal cancer',
      image: '/reactcr/static/images/Metastatic colorectal cancer.svg',
      color: '#303133'
    },
    {
      name: 'Metastatic epithelial cancers',
      image: '/reactcr/static/images/Metastatic epithelial cancers.svg',
      color: '#303133'
    },
    {
      name: 'Multiple myeloma',
      image: '/reactcr/static/images/Multiple myeloma.svg',
      color: '#303133'
    },
    {
      name: 'Non-small cell lung cancer',
      image: '/reactcr/static/images/Non-small cell lung cancer.svg',
      color: '#303133'
    },
    {
      name: 'Ovarian cancer',
      image: '/reactcr/static/images/Ovarian cancer.svg',
      color: '#303133'
    },
    {
      name: 'Pancreatic cancer',
      image: '/reactcr/static/images/Pancreatic cancer.svg',
      color: '#303133'
    },
    {
      name: 'Primary localized urothelial carcinoma of the bladder',
      image: '/reactcr/static/images/Primary localized urothelial carcinoma of the blad.svg',
      color: '#303133'
    },
    {
      name: 'Renal cell carcinoma',
      image: '/reactcr/static/images/renal cell carcinoma.svg',
      color: '#303133'
    }
  ],
  '1-2': [ // Autoimmune disease
    {
      name: 'Ankylosing spondylitis',
      image: '/reactcr/static/images/Ankylosing spondylitis.svg',
      color: '#303133'
    },
    {
      name: 'Celiac disease',
      image: '/reactcr/static/images/Celiac disease.svg',
      color: '#303133'
    },
    {
      name: 'Diabetes',
      image: '/reactcr/static/images/Diabetes.svg',
      color: '#303133'
    },
    {
      name: 'Rheumatoid arthritis',
      image: '/reactcr/static/images/Rheumatoid arthritis.svg',
      color: '#303133'
    }
  ],
  '1-3': [ // Infectious disease
    {
      name: 'CMV',
      image: '/reactcr/static/images/CMV.svg',
      color: '#303133'
    },
    {
      name: 'COVID-19',
      image: '/reactcr/static/images/COVID-19.svg',
      color: '#303133'
    },
    {
      name: 'DENV',
      image: '/reactcr/static/images/DENV.svg',
      color: '#303133'
    },
    {
      name: 'EBV',
      image: '/reactcr/static/images/EBV.svg',
      color: '#303133'
    },
    {
      name: 'HCV',
      image: '/reactcr/static/images/HCV.svg',
      color: '#303133'
    },
    {
      name: 'HEV',
      image: '/reactcr/static/images/HEV.svg',
      color: '#303133'
    },
    {
      name: 'HIV',
      image: '/reactcr/static/images/HIV.svg',
      color: '#303133'
    },
    {
      name: 'HSV',
      image: '/reactcr/static/images/HSV.svg',
      color: '#303133'
    },
    {
      name: 'HAM-TSP',
      image: '/reactcr/static/images/HAM-TSP.svg',
      color: '#303133'
    },
    {
      name: 'Influenza',
      image: '/reactcr/static/images/Influenza.svg',
      color: '#303133'
    },
    {
      name: 'Influenza A',
      image: '/reactcr/static/images/Influenza A.svg',
      color: '#303133'
    },
    {
      name: 'MERS',
      image: '/reactcr/static/images/MERS.svg',
      color: '#303133'
    }
  ]
}

const diseases = ref<Disease[]>(diseaseData['1-1'])

const handleSelect = (index: string) => {
  diseases.value = diseaseData[index]
  activeIndex.value = index
}

const router = useRouter()

const getDiseaseCategory = (index: string) => {
  switch (index) {
    case '1-1':
      return 'Tumor'
    case '1-2':
      return 'Autoimmune disease'
    case '1-3':
      return 'Infectious disease'
    default:
      return ''
  }
}

const navigateToDisease = (diseaseName: string) => {
  const category = getDiseaseCategory(activeIndex.value)
  router.push(`/disease/${encodeURIComponent(`${category}:${diseaseName}`)}`)
}

const fetchTCRs = async () => {
  try {
    const response = await fetch('./api/tcr/tcr/')
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }

    const data = await response.json()
    // console.log(data)
  } catch (err) {
    console.error('Error fetching TCRs:', err)
  }
}

fetchTCRs()
</script>

<style scoped>
.el-menu-vertical {
  border-right: none;
}

.disease-card {
  transition: transform 0.2s ease-in-out;
}

.disease-card:hover {
  transform: scale(1.05);
}

.el-image {
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 10px;
}

.desText {
  transition: color 0.2s ease-in-out;
}

.disease-card:hover .desText {
  color: #166534 !important;
}

.el-menu-item.is-active {
  color: rgb(198, 0, 33);
}

.el-menu-item {
  min-width: 165px;
  padding-left: 40px !important;
}

.el-sub-menu__title {
  padding-left: 20px !important;
  color: black;
}

.el-menu-item span {
  color: black;
}

.el-image__inner {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.desText {
  margin-top: 10px;
  padding-bottom: 5px;
}

/* 添加子菜单箭头样式 */
:deep(.el-sub-menu__title .el-sub-menu__icon-arrow) {
  color: black;
  font-weight: bold;
}
</style>